import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { StyledTextField } from '../../../../healtheraComponents';
import { TextFieldProps } from '@material-ui/core/TextField';

const PriceInput = (props: TextFieldProps) => {
  return (
    <StyledTextField
      InputProps={{
        startAdornment: <InputAdornment position="start">£</InputAdornment>,
      }}
      value={props.value || 0}
      type="number"
      {...props}
    />
  );
};

export default PriceInput;
